import DataTableView from "@components/views/datatable-view";
import usePageChange from "@hooks/use-page-change";
import usePeople from "./use-people";

export const People = () => {
    const {
        data: { people = [], pagination = {} },
        loading,
        columns,
        setQueryParams
    } = usePeople();

    /* A custom hook that is used to handle the pagination. */
    const { handlePageChange, handlePerRowsChange } = usePageChange({
        setQueryParams
    });
    return (
        <>
            <DataTableView
                moduleName={"Peoples"}
                loading={loading}
                tableProps={{
                    data: people,
                    columns,
                    handlePageChange,
                    handlePerRowsChange,
                    pagination
                }}/>
        </>
    );
};